import { render, staticRenderFns } from "./LoginPasswordProvider.vue?vue&type=template&id=0fb9c330&scoped=true&"
import script from "./LoginPasswordProvider.vue?vue&type=script&lang=js&"
export * from "./LoginPasswordProvider.vue?vue&type=script&lang=js&"
import style0 from "./LoginPasswordProvider.vue?vue&type=style&index=0&id=0fb9c330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9c330",
  null
  
)

export default component.exports